import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material'

interface DiscardChangesDialogProps {
  open: boolean
  title: string
  message: string
  onKeepEditing: () => void
  onDiscard: () => void
}

// Asked when leaving a form that holds changes nothing has saved. Keep editing
// is the default action so Enter never throws work away.
export default function DiscardChangesDialog({
  open,
  title,
  message,
  onKeepEditing,
  onDiscard,
}: DiscardChangesDialogProps) {
  return (
    <Dialog open={open} onClose={onKeepEditing} maxWidth="xs" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onDiscard} color="error">
          Discard changes
        </Button>
        <Button onClick={onKeepEditing} variant="contained" autoFocus>
          Keep editing
        </Button>
      </DialogActions>
    </Dialog>
  )
}
